// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1YaPS","header":"ReportDetails_header__FKWN2","title":"ReportDetails_title__2UDSD","left":"ReportDetails_left__ucKw7"};